/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import './ApplyLetterModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import CompDirection from '../../../themes/CompDirection';
import { FileInput } from '../../../../components';
import { useTranslate, useValidation } from '../../../../hooks';
import {
  useCreateLetter,
  useListLetterType,
} from '../../../../pages/letterGeneration/api';
import { useAppSelector } from '../../../../infra/hooks';
import { DropdownType } from '../../../../types';
import { createLetterValidations } from '../validations';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
}

const ApplyLetterModalPresenter = ({ isModalOpen, closeModal }: ModalProps) => {
  const companyId = useAppSelector((state) => state?.authSlice?.company_id);

  const { createLetter, isCreatingLetter } = useCreateLetter();

  const [remarks, setRemarks] = useState('');
  const [addresTo, setAddresTo] = useState('');
  const [country, setCountry] = useState('');
  const [letterType, setLetterType] = useState<DropdownType | null>(null);
  const [language, setLanguage] = useState<DropdownType | null>(null);
  const [file, setFile] = useState<(File & { preview: string }) | null>(null);

  const { translate } = useTranslate();
  const { errors, validate } = useValidation(createLetterValidations, {
    letterType: letterType?.id,
    language: language?.id,
  });

  const { data: letterTypes, isLoading: isFetchingLetterTypes } =
    useListLetterType({ params: {} });

  const handleLetterType = (type: DropdownType) => {
    setLetterType(type);
  };

  const handleFile = (file: File & { preview: string }) => {
    setFile(file);
  };

  const onSubmit = async () => {
    if (await validate()) {
      const formData = new FormData();
      formData.append('companyId', companyId.toString());
      formData.append('letterType', letterType?.id.toString()!);
      formData.append('language', language?.id.toString()!);

      if (remarks) {
        formData.append('remarks', remarks);
      }
      if (addresTo) {
        formData.append('addressto', addresTo);
      }
      if (country) {
        formData.append('countrydetails', country);
      }

      if (file) {
        formData.append('attachments[]', file);
      }

      await createLetter(formData, {
        onSuccess() {
          closeModal();
        },
      });

      return;
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="550px"
    >
      <ModalHeader
        modal={{ modal_title: translate('Apply Letter') || '' }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={12}>
            <CustomAutoComplete
              label={translate('Letter Type') || ''}
              options={letterTypes?.map(
                (letterType: { id: string; title: string }) => ({
                  id: letterType.id,
                  label: letterType.title,
                }),
              )}
              errors={errors['letterType']}
              isLoading={isFetchingLetterTypes}
              value={letterType}
              onChange={(event: any, newValue: any) => {
                handleLetterType(newValue);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomAutoComplete
              label={translate('language') || ''}
              options={[
                {
                  label: 'English',
                  id: 'en',
                },
                {
                  label: 'Arabic',
                  id: 'ar',
                },
              ]}
              errors={errors['language']}
              value={language}
              onChange={(event: any, newValue: any) => {
                setLanguage(newValue);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              type="string"
              label={translate('Reason') || ''}
              placeholder={translate('Write Reason') || ''}
              value={remarks}
              multiline
              onChange={(e: any) => setRemarks(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              type="string"
              label={translate('Address to') || ''}
              placeholder={translate('Write Address to') || ''}
              value={addresTo}
              multiline
              onChange={(e: any) => setAddresTo(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              type="string"
              label={translate('Emirates / Country') || ''}
              placeholder={translate('Write Emirates / Country') || ''}
              value={country}
              multiline
              onChange={(e: any) => setCountry(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <FileInput
              files={file}
              handleFiles={handleFile}
              name="attachment"
            />
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: '35px' }} />

      <ModalFooter
        isSubmitting={isCreatingLetter}
        onClickSubmit={onSubmit}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default ApplyLetterModalPresenter;
